var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96151 16C5.93084 16 4.16068 15.3368 2.65101 14.0105C1.14135 12.6843 0.267928 11.0142 0.0307617 9H1.04226C1.3141 10.7205 2.09776 12.1507 3.39326 13.2905C4.68876 14.4302 6.21151 15 7.96151 15C9.91151 15 11.5657 14.3208 12.924 12.9625C14.2823 11.6042 14.9615 9.95 14.9615 8C14.9615 6.05 14.2823 4.39583 12.924 3.0375C11.5657 1.67917 9.91151 1 7.96151 1C6.92684 1 5.95443 1.21858 5.04426 1.65575C4.13393 2.09292 3.33068 2.69483 2.63451 3.4615H5.11551V4.4615H0.961512V0.30775H1.96151V2.69625C2.73468 1.84742 3.64076 1.18583 4.67976 0.711501C5.71893 0.237167 6.81284 0 7.96151 0C9.07051 0 10.1099 0.208666 11.0798 0.625999C12.0496 1.04333 12.897 1.6145 13.622 2.3395C14.347 3.0645 14.9182 3.91192 15.3355 4.88175C15.7528 5.85158 15.9615 6.891 15.9615 8C15.9615 9.109 15.7528 10.1484 15.3355 11.1183C14.9182 12.0881 14.347 12.9355 13.622 13.6605C12.897 14.3855 12.0496 14.9567 11.0798 15.374C10.1099 15.7913 9.07051 16 7.96151 16ZM11.1655 11.8538L7.51926 8.20775V3H8.51926V7.79225L11.873 11.1463L11.1655 11.8538Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrailIcon);
export default __webpack_public_path__ + "static/media/audit-trail-icon.58d9467f3022e7dec25e6fb930fdbf25.svg";
export { ForwardRef as ReactComponent };